import React from 'react';
import Icon from 'react-icons-kit';
import { ic_business } from 'react-icons-kit/md/ic_business';
import { ic_person } from 'react-icons-kit/md/ic_person';

import { styled } from '../theme';
import Image from './Image';

const SIZES = {
    small: 20,
    default: 40,
    medium: 80,
    big: 114,
};
export type AvatarSize = keyof typeof SIZES;
const getSize = (size: AvatarSize): number => SIZES[size ? size : 'default'];

export const RoundAvatarShape = 'round';
export const SquareAvatarShape = 'square';
export type AvatarShape = 'round' | 'square';

export const AccountAvatarType = 'account';
export const OrganizationAvatarType = 'organization';
export type AvatarType = 'account' | 'organization';

const getMissingAvatarIcon = (type: AvatarType) =>
    AccountAvatarType === type ? ic_person : ic_business;

const MissingAvatar = styled(Icon)(({ theme, type, shape }) => ({
    borderRadius: shape === RoundAvatarShape ? '50%' : theme.borderRadius.base,
    border: '1px solid lightgray',
    display: 'inline-block',
    padding: 4,
}));

const defaultProps = {
    size: 'default' as const,
    shape: RoundAvatarShape,
    type: AccountAvatarType,
};

type Props = {
    className?: string;
    alt?: string;
    size?: AvatarSize;
    shape: AvatarShape;
    src: string;
    type?: AvatarType;
};

const Avatar: React.FC<Props> = ({ src, size, alt, className, shape, type, ...props }) => {
    const sizeValue = getSize(size);
    if (src) {
        const imageStyle = { height: sizeValue, width: sizeValue };
        const sizeGetter = () => sizeValue;

        return (
            <Image
                className={className}
                title={alt}
                src={src}
                style={imageStyle}
                shape={shape}
                type={type}
                getSize={sizeGetter}
            />
        );
    }

    return (
        <MissingAvatar
            className={className}
            size={sizeValue - 10}
            icon={getMissingAvatarIcon(type)}
            shape={shape}
            type={type}
        />
    );
};

Avatar.defaultProps = defaultProps;

export default Avatar;
